import { FC } from 'react';
import { SvgIcon } from '@edikk-edikk/svg-icon';
import { FormattedMessage } from 'react-intl';
import Phone2Svg from '#srcIcons/phone-2.svg';
import { useAdvertDetailContext } from '#advertDetail/hooks';
import { Button, ButtonVariant } from '#components/button';
import modelDetailContactButtonListCss from '../../assets/model-detail/model-detail-contact-button-list.module.scss';
import { useVariantByStyle } from '#hooks/use-variant-by-style';

const Call: FC = () => {
  const {
    advert: {
      contactData,
    },
  } = useAdvertDetailContext();
  const variantByStyle = useVariantByStyle();

  if (!contactData.phone) {
    return null;
  }

  return (
    <Button
      variant={variantByStyle(ButtonVariant.black, ButtonVariant.vividCrimson)}
      fontWeight600
      linkSimpleProps={{
        href: contactData.phone.url,
        target: '_blank',
        rel: 'noreferrer',
      }}
      contentAdditionalClassName={modelDetailContactButtonListCss.modelDetailContactButtonList__itemContent}
      additionalClassName={modelDetailContactButtonListCss.modelDetailContactButtonList__item}
    >
      <SvgIcon Component={Phone2Svg} size={16} isWithoutStroke />
      <FormattedMessage defaultMessage="Call" />
    </Button>
  );
};

export { Call };
